export class LoadAccountProvincesNewFromApi {
    public static readonly type: string = '[Accounts API] Load provinces';
}
